export default __webpack_public_path__ + "static/media/camera-permission.7c8ee9ad.png";